import { render, staticRenderFns } from "./AiApi.vue?vue&type=template&id=9fc637e8&"
import script from "./AiApi.vue?vue&type=script&lang=js&"
export * from "./AiApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports